import React from 'react'
import "./EndMsg.scss";
export default function EndMsg() {
  return (
    <div>
      <h2 className="end-text">You've reached the end 🎉</h2>
    </div>
  )
}
